import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  AiEvaluationDetailResponse,
  AiEvaluationsPage,
  AiEvaluationsQuery,
} from './ai-evaluations.types';

/** Admin AI-evaluations API: paginated Claude evaluation log + spend summary. */
@Injectable({ providedIn: 'root' })
export class AiEvaluationsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/admin/ai-evaluations`;

  /**
   * One page of AI evaluation calls, grouped by the target they ran against and
   * optionally filtered by purpose / recommendation. `page_size` counts GROUPS,
   * so a page carries more rows than that.
   */
  list(query: AiEvaluationsQuery = {}): Observable<AiEvaluationsPage> {
    let params = new HttpParams();
    if (query.page) params = params.set('page', query.page);
    if (query.page_size) params = params.set('page_size', query.page_size);
    if (query.purpose) params = params.set('purpose', query.purpose);
    if (query.recommendation) {
      params = params.set('recommendation', query.recommendation);
    }
    return this.http.get<AiEvaluationsPage>(`${this.base}/`, { params });
  }

  /** One evaluation: full metadata + the prompt/response bodies sent to Claude. */
  detail(shortId: string): Observable<AiEvaluationDetailResponse> {
    return this.http.get<AiEvaluationDetailResponse>(`${this.base}/${shortId}/`);
  }
}
